var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8045 0.500243C13.6215 1.54377 15.6919 4.11393 15.9998 7.2H12.8071C12.6772 4.09533 11.7992 1.91663 10.809 0.501942L10.8045 0.500243ZM7.99995 0C5.5537 1.15358 4.87355 4.86788 4.76676 7.2H11.1977C11.086 4.76125 10.3904 1.31804 7.99995 0ZM5.1429 0.51987C4.15789 1.93498 3.28669 4.10842 3.15733 7.2H0C0.306006 4.1331 2.35261 1.57573 5.1429 0.51987ZM10.8047 15.4998C13.6217 14.4562 15.6921 11.8861 16 8.8H12.8073C12.6774 11.9047 11.7994 14.0834 10.8092 15.4981L10.8047 15.4998ZM8.00015 16C5.55389 14.8464 4.87375 11.1321 4.76695 8.8H11.1979C11.0862 11.2388 10.3906 14.682 8.00015 16ZM5.1431 15.4801C4.15809 14.065 3.28689 11.8916 3.15752 8.8H0.000196279C0.306203 11.8669 2.3528 14.4243 5.1431 15.4801Z",
    fill: "url(#paint0_radial_9537_5741)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9537_5741",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8 8) rotate(90) scale(8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.987ea7eeeb0c7858a03197bc4b66dca4.svg";
export { ForwardRef as ReactComponent };